module.exports = __webpack_public_path__ + "img/main-gallery2-mob.7ee2dec8.webp";